'use client';

import Navigation, { NavigationOptions } from './Navigation';

import * as Styled from './styled';
import { colors } from '@/styles';

export const ExploreBodyWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div style={{ background: `linear-gradient(to bottom, ${colors.secondary.lightGray1} 0%, transparent 25vh)` }}>
      {children}
    </div>
  );
};

const Header = ({ selected = 'explore', children }: { selected: NavigationOptions; children?: React.ReactNode }) => {
  return (
    <Styled.Header>
      {children && <Styled.HeaderContent>{children}</Styled.HeaderContent>}
      <Navigation selected={selected} />
    </Styled.Header>
  );
};

export default Header;
